import { observer } from "mobx-react-lite";
import { ReactNode, useEffect } from "react";
import { Outlet } from "react-router-dom";

import { AppModel } from "../../app/app-model";
import { Spinner } from "../../components/ui-kit/spinner";

export const AdminRoute = observer(function AdminRoute(props: {
  app: AppModel;
  children?: ReactNode;
}) {
  useEffect(() => {
    if (!props.app.adminShit) {
      void props.app.initAdmin();
    }
  }, [props.app]);

  return props.app.adminShit?.initialized ? <Outlet /> : <Spinner />;
});
